import { styled, CSSObject } from '../../theming';
import { responsiveProp } from '../../utils/responsiveProp';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { fallbackTheme } from '../../theming/fallbackTheme';

import type { TitleProps } from './types';
import { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';

// TODO: change string to color props, we should be precise with it
const getTextColorVariant = (color: string, theme: BabbelTheme) => {
  const colorSemanticTokens = { color: '' };

  switch (color) {
    case 'default':
      colorSemanticTokens.color = fallbackTheme(theme).color.neutral.onSurfaceDefault;
      break;
    case 'subdued1':
      colorSemanticTokens.color = fallbackTheme(theme).color.neutral.onSurfaceSubdued1;
      break;
    case 'subdued2':
      colorSemanticTokens.color = fallbackTheme(theme).color.neutral.onSurfaceSubdued2;
      break;
    case 'inverse':
      colorSemanticTokens.color = fallbackTheme(theme).color.neutral.onSurfaceInverse;
      break;
    default:
      colorSemanticTokens.color = color;
  }

  return colorSemanticTokens;
};

export const StyledTitle = styled.h1<TitleProps<'h1'>>`
  ${({ size, wordBreak, color, textAlign, theme }): CSSObject => ({
    fontFamily: `${tokens.typography.title.xsmall.fontFamily}, serif`,
    fontWeight: '400',
    ...(color && getTextColorVariant(color, theme)),
    ...responsiveProp(size, (size) => ({
      fontSize: tokens.typography.title[size].fontSize,
      lineHeight: tokens.typography.title[size].lineHeight,
    })),
    ...(textAlign &&
      responsiveProp(textAlign, (textAlign) => ({
        textAlign,
      }))),
    ...(wordBreak && {
      overflowWrap: 'anywhere',
    }),
  })}
`;
